"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTableActionCell = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const GetApp_1 = __importDefault(require("@material-ui/icons/GetApp"));
const files_context_1 = require("../../common/files/files-context");
const table_field_toolbar_button_1 = require("../../components/table-field/table-field-toolbar-button");
const table_field_context_1 = require("../../components/table-field/table-field-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function FileTableActionCell(props) {
    const { getFileUrl } = react_1.useContext(files_context_1.FilesContext);
    const { disabled, showRemoveDialog } = react_1.useContext(table_field_context_1.TableFieldContext);
    const handleRemove = event_callback_hook_1.useEventCallback(() => {
        showRemoveDialog(props.index);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_FILE_TABLE_BTN_DOWNLOAD", defaultMessage: "St\u00E1hnout" }), IconComponent: GetApp_1.default, disabled: false, show: true, href: getFileUrl(props.rowValue.id) }),
        react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_FILE_TABLE_BTN_REMOVE", defaultMessage: "Smazat" }), IconComponent: Delete_1.default, disabled: disabled, show: true, onClick: handleRemove })));
}
exports.FileTableActionCell = FileTableActionCell;
//# sourceMappingURL=file-table-action-cell.js.map